<template>
  <span :class="badgeClass">
    <b-svg
      v-if="iconName"
      class="b-badge-icon"
      :name="iconName"
      :size="iconSize"
    />
    <slot />
  </span>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

const COLORS = {
  DEFAULT: 'default',
  RED: 'red',
  GREEN: 'green',
  GRAY: 'gray',
  ORANGE: 'orange',
  TEAL: 'teal',
  VIOLET: 'violet',
  WHITE: 'white',
  LIME: 'lime',
}

const SIZES = {
  DEFAULT: 'default',
  LG: 'lg',
  XL: 'xl',
}

export default defineComponent({
  props: {
    color: {
      type: String,
      validator: (v: string) => Object.values(COLORS).includes(v),
      default: 'default',
    },
    size: {
      type: String,
      validator: (v: string) => Object.values(SIZES).includes(v),
      default: 'default',
    },
    iconName: {
      type: String,
    },
    iconSize: {
      type: Number,
      default: null,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    pill: {
      type: Boolean,
      default: false,
    },
  },

  setup (props) {
    const badgeClass = computed(() => {
      return {
        'b-badge': true,
        [`b-badge-${props.color}`]: !!props.color && props.color !== 'default',
        [`b-badge-size-${props.size}`]: !!props.size && props.size !== 'default',
        'b-badge-filled': !!props.filled,
        'b-badge-pill': !!props.pill,
      }
    })

    return {
      badgeClass,
    }
  },
})

</script>
